import { useTranslations } from 'next-intl'
import NextLink from 'next/link'
import {
  Box,
  Button,
  Heading,
  Flex,
  useBreakpointValue,
} from '@chakra-ui/react'
import { FiArrowDown } from 'react-icons/fi'
import { ContainerBase } from '@/components/containers/ContainerBase'

export function Hero() {
  const t = useTranslations()
  return (
    <Box
      bg={'black'}
      color={'white'}
      textAlign={{ base: 'center', md: 'left' }}
      py={{ base: '85px', md: '180px', xxl: '220px' }}
      overflow={'hidden'}
      position={'relative'}
      // 100% viewport height - header height
      maxHeight={{ base: 'calc(100vh - 54px)', md: 'calc(100vh - 82px)' }}
    >
      <Box
        position={'absolute'}
        zIndex={1}
        as="video"
        h={{ base: '100%', lg: 'auto' }}
        w={{ base: 'auto', lg: '100%' }}
        top={{ base: 0, md: '50%' }}
        left={'50%'}
        transform={{
          base: 'translateX(-50%)',
          md: 'translateX(-50%) translateY(-50%)',
        }}
        maxW="inherit"
        mx="auto"
        autoPlay
        muted
        loop
        playsInline
        poster="/img/hero/minebitcoin.fallback.png"
      >
        <source src="/img/hero/minebitcoin-v2.h264.mp4" type="video/mp4" />
      </Box>
      <ContainerBase
        position={'relative'}
        maxWidth={{ xxl: 'container.xl' }}
        py={0}
        px={4}
        zIndex={2}
      >
        <Heading
          as="h4"
          fontSize={{ base: '16px', md: '20px', xl: '24px' }}
          fontWeight={600}
          lineHeight="normal"
          mb={{ base: 2, md: 4 }}
        >
          {t('minebitcoin.hero.subtitle')}
        </Heading>
        <Heading
          as="h1"
          variant="spaceGrotesk"
          fontSize={{
            base: '40px',
            xl: '64px',
          }}
          fontWeight={300}
          lineHeight="normal"
          mb={{ base: 2, md: 4 }}
        >
          {t.rich('minebitcoin.hero.title', {
            br: () => <br />,
          })}
        </Heading>
        <Heading
          as="h3"
          fontSize={{ base: '18px', md: '20px', xl: '26px' }}
          fontWeight={400}
          lineHeight={1.33}
          mb={{ base: 6, md: 4 }}
        >
          {t('minebitcoin.hero.description')}
        </Heading>
        <Flex
          gridGap={{ base: 2, md: '27px' }}
          flexWrap="wrap"
          justifyContent={{ base: 'center', md: 'start' }}
        >
          <NextLink href="/hardware" passHref>
            <Button
              as="a"
              variant="brandGradient"
              mb={{ base: 4, sm: 0 }}
              zIndex={5}
              width={{ base: '200px', md: '288px' }}
              py="6"
              fontWeight={600}
              fontSize={{ base: 'md', md: 'lg' }}
            >
              {t('buttons.buy-now')}
            </Button>
          </NextLink>
          <NextLink href="#results" passHref scroll={false}>
            <Button
              as="a"
              variant="outline"
              mb={{ base: 4, sm: 0 }}
              zIndex={5}
              width={{ base: '200px', md: '150px' }}
              rightIcon={useBreakpointValue({
                base: <FiArrowDown />,
                md: undefined,
              })}
              py="6"
              fontWeight={600}
              fontSize={{ base: 'md', md: 'lg' }}
              color={'white'}
              _hover={{
                background: 'whiteAlpha.400',
              }}
            >
              {t('buttons.learn-more')}
            </Button>
          </NextLink>
        </Flex>
      </ContainerBase>
    </Box>
  )
}
